module.exports = __webpack_public_path__ + "img/icommunity_twoblock.1848b546.jpg";